import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import baseUrl from "../../../../api/baseUrl";
import { toast } from "react-toastify";
interface Props {
  aboutContent: string;
  onAboutChange: (content: string) => void;
}

export const AboutUs: React.FC<Props> = ({ aboutContent, onAboutChange }) => {
  const [content, setContent] = useState(aboutContent);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const handleSave = () => {
    onAboutChange(content);
    baseUrl
      .patch("/client/booking/updateBookClinic", {
        about: content,
      })
      .then((response) => {
        if (response.data?.success) {
          toast.success("About Us saved successfully!");
        } else {
          toast.error("Failed to save About Us");
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(error?.response?.data?.message || "Failed to save About Us");
      });
  };

  return (
    <section className="bg-white rounded-[8px] shadow-lg shadow-slate-200/50 border border-slate-100 p-3">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5 pb-2.5 mb-3 border-b border-slate-200">
        <h2 className="text-xs font-bold text-primary mb-0">About Us</h2>
        <button 
          className="flex items-center gap-1.5 px-4 py-2.5 bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
          onClick={handleSave}
        >
          <SaveAltIcon sx={{ fontSize: 16 }} />
          Save
        </button>
      </div>

      <div className="[&_.ql-toolbar]:rounded-t-lg [&_.ql-container]:rounded-b-lg [&_.ql-container]:min-h-[150px] [&_.ql-container]:text-sm">
        <ReactQuill
          theme="snow"
          value={content}
          onChange={setContent}
          modules={modules}
        />
      </div>
    </section>
  );
};
